import React, { useState } from 'react';
import { MessageSquare, X, Bot, ChevronRight } from 'lucide-react';
import ChatBot from './ChatBot';

const WHATSAPP_URL = 'https://wa.me/5219841855185';

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.75-.72 2-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35M12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.32l-.34-.2-3.57.94.95-3.48-.22-.36a9.4 9.4 0 0 1-1.44-5.01c0-5.2 4.24-9.44 9.44-9.44 2.52 0 4.89.98 6.67 2.77a9.37 9.37 0 0 1 2.76 6.68c0 5.2-4.24 9.43-9.44 9.43m8.03-17.46A11.27 11.27 0 0 0 12.05.72C5.8.72.7 5.8.7 12.07c0 2 .52 3.95 1.52 5.67L.6 23.28l5.68-1.49a11.33 11.33 0 0 0 5.77 1.47h.01c6.26 0 11.35-5.09 11.35-11.35 0-3.03-1.18-5.88-3.33-8.02" />
  </svg>
);

const Option = ({ testId, icon, iconBg, title, subtitle, onClick }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-gray-50 transition-colors duration-200 text-left group"
  >
    <span className={`w-11 h-11 rounded-full flex items-center justify-center text-white shrink-0 ${iconBg}`}>{icon}</span>
    <span className="flex-1">
      <span className="block text-sm font-semibold text-notaria-primary">{title}</span>
      <span className="block text-xs text-gray-500 text-left">{subtitle}</span>
    </span>
    <ChevronRight className="w-4 h-4 text-gray-400 transition-transform duration-200 group-hover:translate-x-1" />
  </button>
);

const ContactWidget = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);

  const openChat = () => { setMenuOpen(false); setChatOpen(true); };
  const openWhatsApp = () => { setMenuOpen(false); window.open(WHATSAPP_URL, '_blank', 'noopener'); };

  if (chatOpen) return <ChatBot onClose={() => setChatOpen(false)} />;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3" data-testid="contact-widget">
      <div
        data-testid="contact-widget-menu"
        className={`w-72 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden origin-bottom-right transition-[opacity,transform] duration-200 ${menuOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-95 pointer-events-none'}`}
      >
        <div className="bg-notaria-primary px-5 py-4">
          <p className="text-white font-semibold text-left">¿Cómo podemos ayudarte?</p>
          <p className="text-white/70 text-xs mt-0.5 text-left">Notaría Pública 90 · Respuesta inmediata</p>
        </div>
        <div className="p-2">
          <Option testId="contact-widget-ai-option" icon={<Bot className="w-5 h-5" />} iconBg="bg-notaria-secondary" title="Asistente Virtual IA" subtitle="Disponible 24/7" onClick={openChat} />
          <Option testId="contact-widget-whatsapp-option" icon={<WhatsAppIcon className="w-5 h-5" />} iconBg="bg-[#25D366]" title="WhatsApp" subtitle="984 185 5185" onClick={openWhatsApp} />
        </div>
      </div>
      <button
        data-testid="contact-widget-toggle"
        onClick={() => setMenuOpen((v) => !v)}
        aria-label={menuOpen ? 'Cerrar opciones de contacto' : 'Abrir opciones de contacto'}
        className="w-16 h-16 rounded-full bg-notaria-secondary hover:bg-notaria-primary text-white shadow-2xl ring-4 ring-white/80 flex items-center justify-center transition-[background-color,transform] duration-300 hover:scale-105"
      >
        {menuOpen ? <X className="w-7 h-7" /> : <MessageSquare className="w-7 h-7" />}
      </button>
    </div>
  );
};

export default ContactWidget;
